module.exports = __webpack_public_path__ + "img/alerticon.c406f4e4.svg";